import { useMemo } from 'react';

export const useTestIdGenerator = (prefix: string) => {
  return useMemo(() => (id: string) => `${prefix}-${id}`, [prefix]);
};
